import React from 'react';
import { Container, ContainerGutter, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { ServiceGroupType, ServiceLayer } from '../../models/services-layer-types';

export const cocheDeSustitucionLayer: ServiceLayer = {
	id: ServiceGroupType.Coberturas,
	header: 'Coberturas',
	title: 'Coche de sustitución',
	subtitle: (
		<Container wrap="always" gutter={ContainerGutter.static300}>
			<Text appearance={TokenTextAppearance.copy200}>
				Que tu coche esté en el taller ya no es razón para cambiar de planes. En tu Servicio Oficial, te dejarán un
				coche de sustitución para que nada pueda detenerte.
			</Text>
			<Text appearance={TokenTextAppearance.copy200}>
				Recuerda que este servicio puede tener un coste adicional. Consulta con tu taller la disponibilidad y
				condiciones específicas.
			</Text>
		</Container>
	),
	ctaText: 'Pide cita en tu taller',
	link: 'action:es-cca-loader--open_layer',
	imageFooter:
		'https://assets.volkswagen.com/is/image/volkswagenag/layer-coche-sustitucion?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT01NDAmZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmMmFiZg==',
};
